<template>
  <div>
    <el-table :data="vx_reserveList" :header-cell-style="headerColor" stripe>
      <el-table-column prop="id" width="100px" label="序號">
        <template slot-scope="scope">
          <!-- 現在改成開成等同預約單紀錄的 舊的先保留 -->
          <!-- <el-button @click="setDriverInfo(scope.row)" type="text" size="lag"> -->
          <el-button @click="openModal(scope.row.id)" type="text" size="lag">
            {{ scope.row.id }}
          </el-button>
        </template>
      </el-table-column>
      <el-table-column
        prop="driverCallNumber"
        width="100px"
        label="隊編/呼號"
      />
      <el-table-column prop="reservationDate" width="200px" label="預約時間" />
      <el-table-column
        prop="onLocation"
        width="400px"
        label="乘客電話/上車地址/下車地點/備註"
      >
        <template slot-scope="scope">
          <span @click="setDriverInfo(scope.row)">
            {{
              passengerInfo(
                scope.row.passengerPhone,
                scope.row.onLocation,
                scope.row.offLocation,
                scope.row.note,
              )
            }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="managerName" label="派車員" />
      <el-table-column label="是否有回覆">
        <template slot-scope="scope">
          <span :style="scope.row.isReply ? 'color: blue' : 'color: red'">
            {{ scope.row.isReply ? '已回覆' : '未回覆' }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="目前進度">
        <template slot-scope="scope">
          <span
            :class="
              statusClass(scope.row.orderCancel, scope.row.driverCallNumber)
            "
          >
            {{
              reserveStatus(
                scope.row.orderCancel,
                scope.row.result,
                scope.row.passengerCancel,
                scope.row.driverCancel,
              )
            }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="managerName" label="取消叫車">
        <template slot-scope="scope">
          <!--NOTE: 若result不是2，即訂單並非完成狀態，可以用btn取消預約訂單-->
          <el-button
            type="danger"
            size="mini"
            round
            plain
            v-if="scope.row.result !== 2"
            @click="cancelReserve(scope.row.id)"
          >
            取消
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-row>
      <el-col :offset="10">
        <el-pagination
          background
          layout="prev, pager, next"
          @current-change="onPageChange"
          :current-page="paging.currentPage"
          :page-count="vx_reservePaging.totalPages"
        />
      </el-col>
    </el-row>
    <ReserveModal ref="reserveDetailModal" />
  </div>
</template>

<script>
import {
  reqUpdateReserve,
  reqReserveDriverInfo,
  reqDriverStatus,
} from '@/api/hailState-v2'
import { mapState, mapMutations, mapActions } from 'vuex'
import dayjs from 'dayjs'
import { Notification } from 'element-ui'
import ReserveModal from '@/components/reserveModal'

export default {
  components: {
    ReserveModal,
  },
  data() {
    return {
      paging: {
        currentPage: 1,
        npp: 10,
        totalPages: 1,
        totalEntries: null,
      },
    }
  },
  computed: {
    ...mapState('hailStateV2', {
      vx_reserveList: 'reserveList',
      vx_reservePaging: 'reservePaging',
    }),
  },
  methods: {
    ...mapActions('hailStateV2', {
      vx_fetchReserveList: 'fetchReserveList',
    }),
    ...mapMutations('hailStateV2', {
      vx_setReserveDriverInfo: 'setReserveDriverInfo',
      vx_setReservePagingCurrentPage: 'setReservePagingCurrentPage',
    }),
    ...mapActions('reserveModal', {
      vx_fetchOrderDetail: 'fetchOrderDetail',
    }),
    ...mapMutations('reserveModal', {
      vx_initModal: 'init',
      vx_setModalId: 'setId',
      vx_setOpenAt: 'setOpenAt',
    }),
    ...mapActions('reserveModal', {
      vx_fetchServiceList: 'fetchServiceList',
    }),
    async cancelReserve(id) {
      try {
        const { result } = await reqUpdateReserve({
          passengerCancelNote: `乘客取消-${dayjs().format(
            'YYYY-MM-DD HH:mm:ss',
          )}`,
          reservationId: id,
        })
        if (result) {
          Notification({
            title: `成功`,
            message: `更新成功`,
            type: 'success',
            position: 'top-right',
          })
          this.vx_fetchReserveList()
          // this.$emit("getReservationList", "");
        } else {
          Notification({
            title: `失敗`,
            message: `更新失敗，請稍後再試`,
            type: 'error',
            position: 'top-right',
          })
        }
      } catch (e) {
        console.error(e)
      }
    },
    async setDriverInfo({ onLocationGps, driverPhone }) {
      if (driverPhone) {
        try {
          const { info: driverInfo } = await reqReserveDriverInfo(driverPhone)
          const { result: driverStatus } = await reqDriverStatus(driverPhone)
          // 將司機資訊放到vuex
          this.vx_setReserveDriverInfo({
            driverInfo,
            driverStatus,
            onLocationGps,
          })
        } catch (e) {
          console.error(e)
        }
      } else {
        Notification({
          title: `尚未有司機接單`,
          type: 'warning',
          position: 'top-right',
        })
      }
    },
    onPageChange(page) {
      this.paging.currentPage = page
      this.vx_setReservePagingCurrentPage(page)
      this.vx_fetchReserveList()
    },
    statusClass(orderCancel, driverCallNumber) {
      if (orderCancel) {
        return 'normal'
      }
      return driverCallNumber ? 'normal' : 'abnormal'
    },
    reserveStatus(orderCancel, result, passengerCancel, driverCancel) {
      if (orderCancel && passengerCancel) {
        return '乘客取消'
      } else if (orderCancel && driverCancel) {
        return '司機取消'
      } else if (result === 0) {
        return '已配對'
      } else if (result === 1) {
        return '已載客'
      } else if (result === 2) {
        return '完成'
      } else if (result === 3) {
        return '未配對完'
      } else if (result === 4) {
        return '等候乘客選擇司機'
      }
      return '尚未有司機接單'
    },
    passengerInfo(phone, on, off, note) {
      return `${phone ? phone : ''}/
        ${on}/
        ${off ? off : '---'}/
        ${note ? note : ''}`
    },
    headerColor({ rowIndex }) {
      if (rowIndex === 0) {
        return 'background-color: #445465;color: #fff;font-weight: 500;'
      }
    },
    async openModal(id) {
      try {
        this.vx_initModal()
        this.vx_setModalId(id)

        // 確保在打開 modal 之前加載所需數據
        await Promise.all([
          this.vx_fetchOrderDetail(),
          this.vx_fetchServiceList(),
        ])

        this.$nextTick(() => {
          this.$refs.reserveDetailModal.openModal()
        })
      } catch (e) {
        console.error(e)
      }
    },
  },
  mounted() {
    this.vx_fetchReserveList()
    this.paging.currentPage = this.vx_reservePaging.currentPage
    this.paging.totalPages = this.vx_reservePaging.totalPages
    this.paging.totalEntries = this.vx_reservePaging.totalEntries
  },
}
</script>
<style lang="scss" scoped>
.abnormal {
  color: red;
}

.normal {
  color: blue;
}
</style>



// WEBPACK FOOTER //
// src/pages/hailState/components-v2/ReserveList.vue